import React, { useState, useEffect } from 'react';
import { Modal, Button, Nav, Tab } from 'react-bootstrap';
import DocumentShareForm from './DocumentShareForm';
import EmailShareForm from './EmailShareForm';
import GenerateLinkForm from './GenerateLinkForm';
import { FiShare2, FiMail, FiLink } from 'react-icons/fi';
import './commonstyle.css';

const ShareDocumentModal = ({
  show,
  onHide,
  fileId,
  // Internal sharing props
  selectedBranches = [],
  onBranchesChange,
  selectedDepartments = [],
  onDepartmentsChange,
  selectedSubDepartments = [],
  onSubDepartmentsChange,
  selectedUsers = [],
  onUsersChange,
  branches = [],
  departments = [],
  subDepartments = [],
  filteredDepartments = [],
  filteredSubDepartments = [],
  availableUsers = [],
  // Email sharing props
  onInternalShare,
  onEmailShare,
  sharing = false,
  // Reset function
  onReset
}) => {
  const [activeTab, setActiveTab] = useState('internal');
  // Email sharing state
  const [email, setEmail] = useState('');
  const [expiryOption, setExpiryOption] = useState('never');
  // Generate link state
  const [linkExpiryOption, setLinkExpiryOption] = useState('never');

  const handleClose = () => {
    // Reset email form
    setEmail('');
    setExpiryOption('never');
    setLinkExpiryOption('never');
    setActiveTab('internal');
    // Call parent reset function
    if (onReset) {
      onReset();
    }
    onHide();
  };

  const handleInternalShare = () => {
    if (onInternalShare) {
      onInternalShare();
    }
  };

  const handleEmailShare = () => {
    if (!email || !email.trim()) {
      return;
    }
    if (onEmailShare) {
      const payload = {
        fileId,
        email: email.trim(),
        permission: 'read',
        expiryOption: expiryOption
      };
      onEmailShare(payload);
    }
  };

  // Reset email form when modal closes
  useEffect(() => {
    if (!show) {
      setEmail('');
      setExpiryOption('never');
      setLinkExpiryOption('never');
      setActiveTab('internal');
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      dialogClassName="modal-top"
    >
      <Modal.Header closeButton>
        <Modal.Title>Share Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Nav variant="tabs" className="mb-3">
            <Nav.Item>
              <Nav.Link eventKey="internal">
                <FiShare2 className="me-2" />
                Internal Sharing
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="email">
                <FiMail className="me-2" />
                Share via Email
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link">
                <FiLink className="me-2" />
                Generate Link
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="internal">
              <DocumentShareForm
                selectedBranches={selectedBranches}
                onBranchesChange={onBranchesChange}
                selectedDepartments={selectedDepartments}
                onDepartmentsChange={onDepartmentsChange}
                selectedSubDepartments={selectedSubDepartments}
                onSubDepartmentsChange={onSubDepartmentsChange}
                branches={branches}
                departments={departments}
                subDepartments={subDepartments}
                filteredDepartments={filteredDepartments}
                filteredSubDepartments={filteredSubDepartments}
                availableUsers={availableUsers}
                selectedUsers={selectedUsers}
                onUsersChange={onUsersChange}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="email">
              <EmailShareForm
                email={email}
                onEmailChange={setEmail}
                expiryOption={expiryOption}
                onExpiryOptionChange={setExpiryOption}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="link">
              <GenerateLinkForm
                fileId={fileId}
                permission="view"
                expiryOption={linkExpiryOption}
                onExpiryOptionChange={setLinkExpiryOption}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer>
        <Button className="doc-form-cancel-btn" onClick={handleClose}>
          Cancel
        </Button>
        {activeTab !== 'link' && (
          <Button
            className="doc-form-submit-btn"
            onClick={activeTab === 'internal' ? handleInternalShare : handleEmailShare}
            disabled={sharing || (activeTab === 'email' && !email?.trim())}
          >
            {sharing ? 'Sharing...' : 'Share'}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ShareDocumentModal;
